import { SafeHtml } from 'ia-react-core';
import styled from 'styled-components';

export const StyledSafeHtml = styled(SafeHtml)`
 font-size:14px;
 span[style="text-decoration: underline;"] {
  font-size:17px;
  text-decoration: none !important;
 }
`;

export const StyledCheckboxItemControlWrapper = styled.div`
 label, p {
  margin-bottom: 0px !important;
 }
`;
